export const Separator = () => {
  return (
    <div>
      <br></br>
      <hr></hr>
      <br></br>
    </div>
  );
};
